<breadcrumb-layout>
	<breadcrumb-item-view (action)="goToLicenseManagement()">{{'license-management' | translate}}</breadcrumb-item-view>
	<breadcrumb-item-view *ngIf="(breadcrumbStateService.navState$ | async) === States.LICENSE_SEATS_MANAGEMENT">
		<span translate="license-management_seat-management"></span>
	</breadcrumb-item-view>
</breadcrumb-layout>
